import Button from "../../../components/shared/Button";
import { IoMdTimer } from "react-icons/io";
import { GiLevelEndFlag } from "react-icons/gi";
import { MdOutlinePlayLesson, MdOutlineQuiz } from "react-icons/md";
import { PiStudentFill } from "react-icons/pi";
import { Link } from "react-router-dom";
import Rating from "../../Rating/Rating";
import PdfViewerDownloader from "../../../components/shared/BookDownload";
import { eachInstrutor } from "../../../components/routes/path";
import { formatAmount } from "../../../utils/formatAmount";

const Card1 = ({
  bookImage,
  bookCaterory,
  bookTitle,
  ratings,
  bookPrice,
  lessonNumber,
  bookStudent,
  to,
  toCategory,
  pdfUrl,
  fileName,
}) => {
  return (
    <div className="flex flex-col sm:gap-5 p-2 sm:p-5 justify-center  sm:flex-row w-full bg-blue-50 rounded-2xl drop-shadow-lg">
      <Link to={to} className="sm:w-[35%] w-full mx-auto">
        <img
          src={bookImage}
          alt=""
          className="hover:scale-[1.02] transition-all ease-in-out delay-200"
        />
      </Link>
      <div className="w-full flex flex-col gap-5 pt-5 sm:pt-0">
        <div className="flex justify-between items-center">
          <Link to={toCategory}>
            <Button
              btnBgColor={
                "bg-[#004C97] hover:bg-white hover:border hover:border-[#333333]"
              }
              btnColor={" text-white hover:text-[#333333]"}
              btnText={bookCaterory}
              padding={"px-5 py-2 transition-all  ease-in-out"}
            />
          </Link>
          <Link
            className="text-[#BCC6CC ] hover:text-[#004C97] font-[Roboto]"
            to={eachInstrutor}
          >
            Muqri
          </Link>
        </div>
        <Link to={to}>
          <h2 className="sm:text-3xl font-bold font-[Roboto] hover:text-[#004C97]">
            {bookTitle}
          </h2>
        </Link>
        <div className="lg:flex grid grid-cols-2 md:grid-cols-3 place-items-center text-sm  gap-x-1.5 sm:gap-6">
          <div className="flex ">
            <IoMdTimer className="text-[#004C97] mt-1 sm:text-xl" />
            <p className="">Lifetime</p>
          </div>
          <div className="flex ">
            <GiLevelEndFlag className="text-[#004C97] mt-1 text-xl" />
            <p className="">All Levels</p>
          </div>
          <div className="flex ">
            <MdOutlinePlayLesson className="text-[#004C97] mt-1 text-xl" />
            <p className="">{lessonNumber}Lesson</p>
          </div>
          <div className="flex ">
            <MdOutlineQuiz className="text-[#004C97] mt-1 text-xl" />
            <p className="">0 Quizzes</p>
          </div>
          <div className="flex ">
            <PiStudentFill className="text-[#004C97] mt-0.5 text-xl" />
            <p className="">{bookStudent}Students</p>
          </div>
        </div>
        <div>
          <Rating ratings={ratings} />
        </div>
        <div className="flex justify-between">
          <p className="font-bold text-slate-500  sm:text-2xl">
            &#8358; {formatAmount(bookPrice)}
          </p>
          <Link to={to}>
            <Button
              btnBgColor={
                "bg-[#004C97] sm:text-lg text-xs hover:bg-white hover:border hover:border-[#333333]"
              }
              btnColor={" text-white hover:text-[#333333]"}
              btnText={"Add To My Profile"}
              padding={"sm:px-5  p-2 transition-all  ease-in-out"}
            />
          </Link>
        </div>
        <div className="sm:text-lg text-xs">
          <PdfViewerDownloader pdfUrl={pdfUrl} fileName={fileName} />
          {/* <Button
            btnBgColor={
              "bg-[#004C97] hover:bg-white hover:border hover:border-[#333333]"
            }
            btnColor={" text-white hover:text-[#333333]"}
            btnText={"Add to cart"}
            padding={"px-5 py-2 transition-all  ease-in-out"}
          /> */}
        </div>
      </div>
    </div>
  );
};

export default Card1;
